import React from "react";
import { inject, observer } from "mobx-react";
import { IAppStore } from "stores/Interfaces";
import { Select as SelectAntd, Form } from "antd";
import { FieldConfig, SelectOption } from "components/common/forms/Interfaces";

interface Props {
  defaultValue?: string;
  store?: IAppStore;
  name: string;
  options: SelectOption[];
  config?: FieldConfig;
  width?: string;
  disabled?: boolean;
  className?: string;
  size?: "large" | "middle" | "small";
}

const Select: React.FC<Props> = ({
  store,
  defaultValue,
  name,
  options,
  config,
  width = "100%",
  disabled,
  className,
  size,
  ...rest
}) => {
  return (
    <Form.Item
      name={name}
      label={config?.label}
      rules={config?.validationRules}
      labelCol={{ span: 24 }}
      style={{ marginBottom: 0, width }}
      {...(config?.extra || {})}
      {...rest}
    >
      <SelectAntd
        showSearch
        defaultValue={defaultValue}
        key={name}
        options={options}
        disabled={disabled}
        className={className}
        size={size}
        filterOption={(input, option) =>
          option?.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      />
    </Form.Item>
  );
};

export default inject("store")(observer(Select));
